// extracted by mini-css-extract-plugin
export default {"sirDPurple":"#352f6e","headSection":"ProOptMain_headSection__VsrRD","addBtn":"ProOptMain_addBtn__ZjMkQ"};